import { Controller } from "stimulus"

export default class extends Controller
  initialize: ->
    file = new App.Models.DirectPost.File $(@element).data()
    directPostFieldsView = new App.Views.DirectPostFieldsView el: @element, model: file